import { useIsFocused } from '@react-navigation/native';

import { useIsLoggedIn } from '../../context/AuthMachine';
import { useLoyaltyPointsQuery } from './GraphQL/LoyaltyPoints.generated';

/**
 * Returns the available points for loyalty, when the customer is logged in and the feature flag is enabled.
 */
export const useLoyaltyAvailablePoints = () => {
  const isLoggedIn = useIsLoggedIn();
  const isFocused = useIsFocused();
  const shouldQueryPoints = isLoggedIn && isFocused;

  const [response] = useLoyaltyPointsQuery({
    requestPolicy: 'cache-and-network',
    pause: !shouldQueryPoints,
  });

  return response?.data?.loyaltyProfile?.points?.available ?? 0;
};
